import React, { useRef } from "react";
import useOcReveal from "../useOcReveal";
import "./Tools.scss";

import phone from "../../../assets/images/home/03-tools/iphone-in-hand.png";
import wavesBg from "../../../assets/images/home/03-tools/tools-section-background.png";
import imgOcMinds from "../../../assets/images/home/03-tools/image-oc-minds.png";
import imgMiniApps from "../../../assets/images/home/03-tools/image-mini-apps.png";
import imgToolkit from "../../../assets/images/home/03-tools/image-ai-toolkit.png";
import imgCredentials from "../../../assets/images/home/03-tools/image-credentials.png";

const ToolCard = ({ pos, title, desc, img, delay }) => (
  <div
    className={`tool-card tool-card--${pos} oc-reveal`}
    style={delay ? { "--oc-delay": delay } : undefined}
  >
    <div className="tool-card__head">
      <p className="tool-card__title">{title}</p>
      <p className="tool-card__desc">{desc}</p>
    </div>
    <img className="tool-card__img" src={img} alt={title} loading="lazy" />
  </div>
);

export default function Tools() {
  const sectionRef = useRef(null);
  useOcReveal(sectionRef);

  return (
    <section className="tools" id="tools" ref={sectionRef}>
      {/* Figma Tools Section Background — 1440×944, wave art 1440×813 @1x */}
      <div className="tools__bg" aria-hidden="true">
        <img className="tools__waves" src={wavesBg} alt="" />
      </div>

      <div className="tools__stage">
        <div className="tools__heading oc-reveal">
          <h2>Tools to support you on your learning journey</h2>
          <p>
            The Open Campus web app is a suite of tools that support and supplement your growth
            trajectory and objectives. Currently in beta, more features are in the works!
          </p>
        </div>

        {/* Figma Ellipse 1478 — glow behind hand */}
        <div className="tools__phone-glow" aria-hidden="true" />

        {/* Figma "iPhone in Hand" — tilt (-5.18deg) is baked into the PNG export */}
        <img
          className="tools__phone oc-reveal"
          src={phone}
          alt="Open Campus web app on iPhone"
          loading="lazy"
          style={{ "--oc-delay": "0.12s" }}
        />

        <ToolCard
          pos="ocminds"
          title="OC Minds"
          desc="Open Campus's AI product. An always-on partner that picks up where you left off, every time."
          img={imgOcMinds}
          delay="0.22s"
        />
        <ToolCard
          pos="miniapps"
          title="Mini-apps"
          desc="Learning, career, and finance, built by OC and the community around it."
          img={imgMiniApps}
          delay="0.22s"
        />
        <ToolCard
          pos="toolkit"
          title="AI Toolkit"
          desc="Go from first prompt to real skill, with people around you doing the same."
          img={imgToolkit}
          delay="0.22s"
        />
        <ToolCard
          pos="credentials"
          title="Credentials"
          desc="Your achievements, verified and provable through your OCID."
          img={imgCredentials}
          delay="0.22s"
        />
      </div>
    </section>
  );
}
